// src/hooks/useOfflineQueue.js
//
// React hook wrapper around the offline mutation queue. Subscribes via
// useSyncExternalStore so components re-render when the queue changes.

import { useSyncExternalStore } from 'react';
import { offlineQueue } from '@caro/shared/services';

export const useOfflineQueue = () => {
  const entries = useSyncExternalStore(
    offlineQueue.subscribe,
    offlineQueue.getSnapshot,
    offlineQueue.getSnapshot,
  );
  return {
    entries,
    pending: entries.filter((e) => e.status !== 'failed'),
    failed: entries.filter((e) => e.status === 'failed'),
    pendingCount: entries.filter((e) => e.status !== 'failed').length,
    failedCount: entries.filter((e) => e.status === 'failed').length,
    replay: offlineQueue.replay,
    remove: offlineQueue.remove,
    clearFailed: offlineQueue.clearFailed,
  };
};

export default useOfflineQueue;
